import { render, staticRenderFns } from "./ButtonPlain.vue?vue&type=template&id=d0c565f2&scoped=true"
import script from "./ButtonPlain.vue?vue&type=script&lang=js"
export * from "./ButtonPlain.vue?vue&type=script&lang=js"
import style0 from "./ButtonPlain.vue?vue&type=style&index=0&id=d0c565f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c565f2",
  null
  
)

export default component.exports